import React, { useState, useEffect } from 'react';
import { TimeContainer, TimeNumber, TimeSubText, TimeItem, TimeText } from './styles';

function TimeUntilStart(): { days: number; hours: number; minutes: number; seconds: number } {
  // Set the target date and time
  const targetDate = new Date('October 12, 2024 11:30:00 PDT');

  // Get the current date and time
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const diff = targetDate.getTime() - currentDate.getTime();

  // Calculate days, hours, minutes, and seconds
  var days = Math.floor(diff / (1000 * 60 * 60 * 24));
  var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((diff % (1000 * 60)) / 1000);

  // ensure days, hours, minutes, and seconds are atleast 0
  days = days < 0 ? 0 : days;
  hours = hours < 0 ? 0 : hours;
  minutes = minutes < 0 ? 0 : minutes;
  seconds = seconds < 0 ? 0 : seconds;

  return { days, hours, minutes, seconds };
}

const TimeBox: React.FC = () => {
  const [time, setTime] = useState(TimeUntilStart());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(TimeUntilStart()); // update the time every second
    }, 1000);

    return () => clearInterval(interval); // clear the interval when the component unmounts
  }, []);

  return (
    <TimeContainer>
      <TimeText>
        Setting sail in
      </TimeText>
      <TimeNumber>
        <TimeItem>{String(time.days).padStart(2, "0")}</TimeItem>
        <div>:</div>
        <TimeItem>{String(time.hours).padStart(2, "0")}</TimeItem>
        <div>:</div>
        <TimeItem>{String(time.minutes).padStart(2, "0")}</TimeItem>
        <div>:</div>
        <TimeItem>{String(time.seconds).padStart(2, "0")}</TimeItem>
      </TimeNumber>
      <TimeSubText>
        <TimeItem>DAYS</TimeItem>
        <TimeItem>HOURS</TimeItem>
        <TimeItem>MINS</TimeItem>
        <TimeItem>SECS</TimeItem>
      </TimeSubText>
    </TimeContainer>
  )
}

export default TimeBox;
